// Local translations
export const T = {
  en_GB: {
    settings: "Settings",
    flows: "Flows",
    pageDescription:
      "Create multi-page forms that clients can fill out. Build custom workflows with pages and fields.",
    documentation: "Documentation",
    fromTemplate: "From Template",
    createFlow: "Create Flow",
  },
  nb_NO: {
    settings: "Innstillinger",
    flows: "Flyter",
    pageDescription:
      "Opprett flersidig skjemaer som kunder kan fylle ut. Bygg tilpassede arbeidsflyter med sider og felt.",
    documentation: "Dokumentasjon",
    fromTemplate: "Fra mal",
    createFlow: "Opprett flyt",
  },
} as const;
